<template>
    <div class="slide container">
        <h2>Volksschule</h2>
        <div align="left">
            <p>Für unsere Jüngsten bzw. unsere Schulanfänger stehen in der Marktgemeinde Bad Wimsbach-Neydharting eine
                Volksschule mit Nachmittagsbetreuung und ein Kindergarten zur Verfügung.</p>
            <p>
                <strong>VOLKSSCHULE BAD WIMSBACH-NEYDHARTING:&nbsp;</strong><br>
                Im November jeden Jahres (Termin kann in den Schulen zeitgerecht erfragt werden) findet in der Zeit
                von 15:00 bis 16:00 Uhr die Schülereinschreibung für das neue Schuljahr statt. Schulpflichtig sind alle
                Kinder, die bis zum 31. August des&nbsp;nächsten Jahres das sechste Lebenjsahr vollenden. Jüngere
                Kinder,
                die zwischen dem 1. September des nächsten Jahres und dem 31. März des folgenden Jahres das 6.
                Lebensjahr
                vollenden, können vorzeitig aufgenommen werden. &nbsp;Ansuchen um Einschulung und ärztliches Zeugnis zur
                Bestätigung der körperlichen Schulreife sowie ein psychologisches Gutachten sind erforderlich! <br>
                Zur Schülereinschreibung bitte folgende Dokumente mitbringen: Geburtsurkunde, Impfnachweis und
                Taufschein.<br>
                Unter der Leitung von Dir. Dipl.-Päd. Renate Friedl wird den Kindern Wissen in 4 Klassen vermittelt.
                Besonders hervorzuheben wäre, dass in dieser Schule täglich ( Freitag bis 14:00 Uhr) auch eine
                Nachmittagsbetreuung für die Kinder bis 16:00 Uhr geboten wird. Während dieser Zeit können die Kinder
                ihre
                Hausaufgaben unter Aufsicht erledigen, aber auch die restliche Zeit bei Spielen und anderen
                Freizeitbeschäftigungen den Nachmittag mit Freunden verbringen.</p>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'PreSchoolInfoSlide',
        components: {},
        props: {},
        methods: {},
    };
</script>

<style scoped>

</style>
